<proffeo-ui-dialog [title]="title | translate">
  <div class="flex h-full w-full flex-col">
    <div class="flex-grow overflow-auto">
      <div class="max-h-[60vh] overflow-y-auto p-4 md:max-h-[50vh]">
        @for (location of locations; track $index) {
          <proffeo-single-location-item
            (locationSelected)="selectedLocation = $event"
            [location]="location"
            [isReadonly]="isReadonly"
            [selectedLocation]="selectedLocation"
          ></proffeo-single-location-item>
        }
      </div>
    </div>
  </div>

  <div
    dialog-actions
    class="flex w-full justify-end gap-2"
  >
    <proffeo-ui-button
      matDialogClose
      text="close"
    ></proffeo-ui-button>
    <proffeo-ui-button
      (clicked)="save()"
      variant="accent"
      text="save-and-close"
    ></proffeo-ui-button>
  </div>
</proffeo-ui-dialog>
